export default "__VITE_ASSET__D185CT8f__"